import {store} from './store.js';
import axios from 'axios';
import {router} from 'vue-router'
export default function setup() {
  axios.interceptors.request.use(function (config) {
    const token = store.getters.token;
        if(token) {
          config.headers.token = token ;
        }
      config.headers.Authenticate = "8B87DCE0BDB360EC4A57F1374E35F9FEB798A0801CDC2B2CEC00DDCC9115D604";
     
    return config;
  }, function (err) {
    return Promise.reject(err);
  });

  axios.interceptors.response.use(
    (response) => {
      if(response.data.status=='401'){
        // store.commit('cerrar_session');
        // setTimeout(() => {
        //   window.location.href = '/login';
        // }, 1000);
      }
      return response;
    },
    (error) => Promise.reject(error),
  );

};
